import * as React from 'react'

import { Box, Grid, GridSpan, Text } from '@factorialco/deprecated-design-system'

import type Plan from 'modules/onboarding/lib/pricing/plans/Plan'
import type { VariantsEnum } from 'modules/onboarding/lib/pricing/plans/types'
import { BUSINESS_VARIANT, ENTERPRISE_VARIANT } from 'modules/onboarding/lib/pricing/plans/utils'

import PlansComparison from './_PlansComparison'
import ToggleCard from './_ToggleCard'

type Props = {
  toggleSelectedPlan: (variant: VariantsEnum) => void
  plan: Plan
  isCore?: boolean
}

const Content = ({ plan, toggleSelectedPlan, isCore = false }: Props) => {
  const varians: VariantsEnum[] = [BUSINESS_VARIANT, ENTERPRISE_VARIANT]
  const planVariants = varians.filter((variant) => plan.hasVariant(variant))

  // FIXME: This is very dependant on the fixed amount of columns from Grid
  const responsiveColSpan = 12 / planVariants.length

  return (
    <Box gap="s24">
      <Text size="200" color="grey800">
        {plan.description}
      </Text>
      <Grid variant="fixed">
        {planVariants.map((variant) => {
          return (
            <Box key={variant} gridColSpan={{ xxs: 12, xs: responsiveColSpan as GridSpan }}>
              <ToggleCard
                features={plan
                  .getFeatures(variant)
                  .filter((feature) => feature.isHighlighted)
                  .map((feature) => feature.title)}
                variant={variant}
                toggle={toggleSelectedPlan}
                isSelected={plan.isSelected && plan.activeVariantType === variant}
                isCore={isCore}
              />
            </Box>
          )
        })}
      </Grid>
      <PlansComparison />
    </Box>
  )
}

export default Content
